import CcConstantLabel from './cc-constant-label.vue';

/* 常量显示，通常用再table中 */
CcConstantLabel.install = function (Vue) {
    Vue.component(CcConstantLabel.name, CcConstantLabel);
};

export default CcConstantLabel;